__webpack_require__.O(0, ["app"], function() {
	__webpack_require__.E("src_components_project_ui_menu_AppMenuExternals_vue");
}, 5);